<template lang="html">
  <div class="relative block h-screen">
    <div class="text-white py-24 px-8 relative md:mb-24 md:mt-24 w-full">
      <span
      :class="'md:w-2/3 text-2xl px-4 mx-auto block pb-4 mb-4 '+ animation +' delay-1s md:text-4xl font-bold text-center leading-none'"
      >{{$attrs.question}}
      </span>
      <span class="w-full px-4">
        <div :class="'bg-white p-4 '+ animation"
        
        >
        <Button
          @answerData="answerData = $event"
          @Disabled="disable = $event"
          @answerCat="answerCats = $event"
          @questionAnswered="animation = $event"
          @AnswerAnimation="answerAnimation = $event"
          class="block w-full p-3 border-2 my-2 text-center"
          v-for="(answer,i) in $attrs.answers" v-bind:key="i"
          :answer="answer"
          :animation="answerAnimation"
          :answerData="answerData"
          :answerCats="answerCats"
          :last="$attrs.lastEntry"
          :category="userCategory"
          :result="$attrs.result"
          :disabled="disable"
          :k="i"
        />
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import Button from "@/components/content/buttons/AnswerButton.vue"
export default {
  components: {
    Button
  },
  data() {
    return {
      disable: false,
      animation: "animated fadeIn",
      answerAnimation: "animated bounceInRight",
      answerData: [],
      answerCats: []
    }
  },
  computed: {
    // Mitchells code //
    userCategory(){
      let array = this.answerCats

      if(array.length === 4) {

      var data = this.answerData
      var dataCount = data.reduce(function(a, b){
        return a + b;
      }, 0)

      if(dataCount == 60) {
          return "T"
        }
        if(dataCount == 66) {
          return "T"
        }
        if(dataCount == 54) {
          return "T"
        }
        if(dataCount == 72) {
          return "T"
        }

      }

      if(array.length < 4) {
        return "entry";
      }

          var modeMap = {};
          var maxEl = array[0], maxCount = 1;
          for(var i = 0; i < array.length; i++)
          {
              var el = array[i];
              if(modeMap[el] == null)
                  modeMap[el] = 1;
              else
                  modeMap[el]++;
              if(modeMap[el] > maxCount)
              {
                  maxEl = el;
                  maxCount = modeMap[el];
              }
            }
            return maxEl;
    }
  },
}
</script>

<style lang="css" scoped>
.question-container {
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
